import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { HelpCenter } from '@egw/features-help-center'

export const HelpCenterPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.help-center.title')} />
      <HelpCenter />
    </Layout>
  )
}
